import { ReportPostUtils } from "../utils";
import { ReportListItem } from "./ListItem";

export const WhatIsHappening = () => {
  return (
    <>
      {ReportPostUtils.whatIsHappeningListItems.map((item) => (
        <ReportListItem key={item} label={item} />
      ))}
    </>
  );
};
